// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ce35910d","453":"c8c6e3e0","606":"ca3c265c","667":"ad9e80b6","977":"14f8ae77"}[chunkId] + ".chunk.js";
};